import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export interface SelectOption<T = string> {
  value: T;
  label: string;
}

interface FilterSelectProps<T extends string = string> {
  label?: string;
  value: T | undefined;
  onChange: (value: T) => void;
  options: SelectOption<T>[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  width?: 'sm' | 'md' | 'lg' | 'full';
}

const widthClasses = {
  sm: 'w-24',
  md: 'w-32',
  lg: 'w-40',
  full: 'w-full'
} as const;

function FilterSelect<T extends string = string>({
  label,
  value,
  onChange,
  options,
  placeholder,
  className = '',
  width = 'md',
  disabled = false
}: FilterSelectProps<T>) {
  // Map empty string to a special value for Radix UI
  const EMPTY_VALUE = '__empty__';
  const mappedValue = value === '' ? EMPTY_VALUE : value || '';

  const handleChange = (newValue: string) => {
    onChange((newValue === EMPTY_VALUE ? '' : newValue) as T);
  };

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {label && <Label>{label}:</Label>}
      <Select value={mappedValue} onValueChange={handleChange} disabled={disabled}>
        <SelectTrigger className={widthClasses[width]}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => {
            const itemValue = option.value === '' ? EMPTY_VALUE : option.value;
            return (
              <SelectItem key={itemValue} value={itemValue}>
                {option.label}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}
export default FilterSelect;
